import { Component, ElementRef, Inject, Input, Renderer2, TemplateRef, ViewChild } from "@angular/core";
import { NzMenuGroupComponent } from "ng-zorro-antd/menu";
import { UiIsMenuInsideDropDownToken } from "../../utils/menu.token";

/**
 * This component extends the base Button directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/button/en
 *
 *
 * Example usage of ui-menu-group
 * <li ui-menu-group menuGroupTitle="SubTitle" nzIcon="appstore"></li>
 *
 * <li ui-menu-group><span title><i nz-icon nzType="appstore"></i><span>SubTitle</span></span></li>
 *
 * <li ui-menu-group [menuGroupTitle]="titleTpl"></li>
 * <ng-template #titleTpl><i nz-icon nzType="appstore"></i><span>SubTitle</span></ng-template>
 *
 *
 * @param menuGroupTitle menuGroupTitle?: string | TemplateRef<void>;
 *
 */

@Component({
  selector: "[ui-menu-group]",
  exportAs: "uiMenuGroup",
  templateUrl: "./menu-group.component.html",
})
export class UiMenuGroupComponent extends NzMenuGroupComponent {
  @Input("menuGroupTitle") nzTitle: string | TemplateRef<void>;
  @ViewChild("titleElement") titleElement?: ElementRef;

  constructor(public elementRef: ElementRef, private uirenderer: Renderer2, @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean) {
    super(elementRef, uirenderer, isMenuInsideDropDown);
  }

  ngAfterViewInit(): void {
    const ulElement = this.titleElement?.nativeElement.nextElementSibling;
    if (ulElement) {
      /** add classname to ul **/
      const className = this.isMenuInsideDropDown ? "ant-dropdown-menu-item-group-list" : "ant-menu-item-group-list";
      this.uirenderer.addClass(ulElement, className);
    }
  }
}
